import { title } from "assets/jss/material-kit-react.jsx";

const productStyle = {
  section: {
    padding: "30px 0",
    textAlign: "center"
  },
  title: {
    ...title,
    marginBottom: "1rem",
    marginTop: "30px",
    minHeight: "32px",
    textDecoration: "none"
  },
  description: {
    color: "#000000"
  }
};

export default productStyle;



// WEBPACK FOOTER //
// ./src/assets/jss/material-kit-react/views/landingPageSections/productStyle.jsx